export const COLORS = {
  SECONDARY: '#46244C',
  BACKGROUND: '#EFFFFD',
  TABLE_HEAD: '#E0E0E0',
};

export const BREAKPOINTS = {
  BIG: '@media (max-width:100em)',
  MEDIUM: '@media (max-width:70em)',
  SMALL: '@media (max-width:40em)',
};
